module.exports = __webpack_public_path__ + "static/media/logo.f266d7b6.svg";